import { Injectable, OnInit } from '@angular/core';
import { Observable, Subject, BehaviorSubject } from 'rxjs';
import { AuthService } from '../modules/shared/services/auth.service';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpResponse } from '@angular/common/http';

@Injectable()
export class JwtInterceptor
  implements HttpInterceptor {

  constructor(
    private authService: AuthService
  ) {}


  intercept = (req: HttpRequest<any>, next: HttpHandler) => {
    const jwt = localStorage.getItem('jwt');

    if (jwt) {
      return next.handle(
        req.clone({
          headers: req.headers.append('Authorization', 'Bearer ' + jwt),
          withCredentials: true
        })
      );
    }

    return next.handle(req);

  }

}
